import React from 'react';
import bem from 'utils/bem';
import Text from 'components/Text';
import Icon from 'components/Icon';

import './index.sass'

const { cnBlock, el } = bem('payment-balance-field');
const PaymentBalanceEmptySlug = ({className}) => {

    return <div className={cnBlock(className, 'empty')}>
        <div className={el('customer-balance')}>
            <div className={el('customer-balance-label')}>
                <Icon name={'wallet'} />
                <Text>Ваш баланс</Text>
            </div>
            <div className={el('customer-balance-value')}>
                <Text serif>0 баллов</Text>
            </div>
        </div>
    </div>

}

export default PaymentBalanceEmptySlug;
